import { render } from "./UserAccountMenu.vue?vue&type=template&id=6f318e54&ts=true"
import script from "./UserAccountMenu.vue?vue&type=script&lang=ts"
export * from "./UserAccountMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__